import { Typography } from '@mui/material'
import { TokenAmount } from '@xylabs/sdk-react'
import { useContext } from 'react'

import { StatsContext } from '../../Contexts'
import { shiftBase10 } from '../../shiftBase10'
import { Property } from '../Property'
import xyoCurrentValue from './xyoCurrentValue'

const TotalFlowedProperty: React.FC = () => {
  const { totalXyoFlowed } = useContext(StatsContext)
  return (
    <Property title="Total XYO Flowed" value={shiftBase10(totalXyoFlowed, -18)?.toString(10)}>
      <TokenAmount marginX={1} amount={totalXyoFlowed} />
      <Typography variant="caption">${shiftBase10(totalXyoFlowed, -18)?.muln(xyoCurrentValue).toString()}</Typography>
    </Property>
  )
}

export default TotalFlowedProperty
